<div class="container-fluid">
    <div class="row pt-4 pb-5 justify-content-center">
        <div class="col d-lg-flex justify-content-lg-around align-items-lg-end max-width text-center">
            <p class="primary-900 p-display mb-0"><strong class="p-display-bold">SEGOFINANCE se compromete</strong></p>
            <div class="barra-separadora d-none d-lg-block"></div>
            <div class="mb-3 mb-lg-0">
                <a href="https://cienciaterapia.org/" target="_blank">
                    <img src="assets/images/footer/logo-cienciaterapia.svg" alt="logo-cienciaterapia">
                </a>
            </div>
            <div>
                <a href="https://kunaiberica.es/" target="_blank">
                    <img src="assets/images/footer/logo-kuna-iberica.svg" alt="logo-kuna-iberica">
                </a>
            </div>
        </div>
    </div>
</div>